module.exports = require("./yrl-VE.d.ts");